// AnimatedModalShell's prop contract, split out to keep the shell under the
// 500-line cap (KAN-786).
import PropTypes from 'prop-types';

export const animatedModalShellPropTypes = {
  isOpen: PropTypes.bool.isRequired,
  onExitComplete: PropTypes.func,
  onEnterMorphComplete: PropTypes.func,
  onScrimClick: PropTypes.func,
  onScrimMouseDown: PropTypes.func,
  zIndex: PropTypes.number,
  dialogStyle: PropTypes.object,
  dialogRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  scrimStyle: PropTypes.object,
  scrimProps: PropTypes.object,
  deferMobileBody: PropTypes.bool,
  panelMotion: PropTypes.oneOf(['auto', 'scale', 'fade', 'pop']),
  scrimEnterFromOpacity: PropTypes.number,
  morphActive: PropTypes.bool,
  morphExitStyle: PropTypes.object,
  morphEnterFromRect: PropTypes.shape({
    top: PropTypes.number, left: PropTypes.number, width: PropTypes.number, height: PropTypes.number,
  }),
  keyboardAware: PropTypes.bool,
  keyboardAlign: PropTypes.oneOf(['center', 'end']),
  typingRest: PropTypes.bool, // KAN-1181: false = never rests on a typing-field tap
  skipEnter: PropTypes.bool,
  children: PropTypes.node,
  dialogProps: PropTypes.object,
};
